import React from "react";
import { Navigate } from "react-router-dom";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { CopyTradingPageDesktop } from "./CopyTradingPage.Desktop";

export const CopyTradingPage: React.FC = () => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  if (!isDesktop) {
    return <Navigate to="/alerts" replace />;
  }

  return <CopyTradingPageDesktop />;
};
